module.exports = __webpack_public_path__ + "img/report.e35f0336.svg";